import React, { useState } from "react";
import CostumeForm from "./CostumeForm";
import CostumeList from "./CostumeList";
import Voting from "./Voting";
import Results from "./Results";
import hw26Logo from "./assets/HW logo 26.jpg";


function App() {
  const [screen, setScreen] = useState("voting"); // landing page
  const [isAdmin, setIsAdmin] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [error, setError] = useState("");

  const correctPassword = process.env.REACT_APP_ADMIN_PASSWORD;

  const handleLogin = () => {
    if (passwordInput === correctPassword) {
      setIsAdmin(true);
      setError("");
      setPasswordInput("");
      setScreen("submission"); // redirect after login
    } else {
      setError("Incorrect password. Try again.");
    }
  };

  const handleLogout = () => {
    setIsAdmin(false);
    setPasswordInput("");
    setScreen("voting"); // back to landing page
  };

  const handleScreenChange = (newScreen) => {
    // If trying to access admin-only pages while not logged in, force login
    if ((newScreen === "submission" || newScreen === "results") && !isAdmin) {
      setScreen("login");
    } else {
      setScreen(newScreen);
    }
  };

  return (
    <div style={{ padding: "0px", paddingBottom: "20px" }}>

      {/* NAVIGATION */}
      <div style={{ marginBottom: "20px"}}>
        <img src={hw26Logo} alt="Cowan House of Halloween Costume Contest" className="app-logo" />

        {/* Go Vote button appears only when on submission/results screens as admin */}
        {isAdmin && (screen === "submission" || screen === "results") && (
          <button onClick={() => handleScreenChange("voting")}>Go Vote!</button>
        )}

        {/* Admin-only navigation after login */}
        {isAdmin && (
          <>
            <button onClick={() => handleScreenChange("submission")}>
              Submission
            </button>
            <button onClick={() => handleScreenChange("results")}>Results</button>
          </>
        )}
      </div>

      {/* LOGIN SCREEN */}
      {screen === "login" && !isAdmin && (
        <div style={{ marginBottom: "20px" }}>
          <h3>Admin Login</h3>
          <input
            type="password"
            placeholder="Enter password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
          />
          <button onClick={handleLogin}>Submit</button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
      )}

      {/* ADMIN SCREEN: Submission */}
      {screen === "submission" && isAdmin && (
        <>
          <CostumeForm />
          <CostumeList />
        </>
      )}

      {/* ADMIN SCREEN: Results */}
      {screen === "results" && isAdmin && <Results />}

      {/* VOTING SCREEN */}
      {screen === "voting" && <Voting />}

      {/* Login button visible if not admin */}
        {!isAdmin && screen !== "login" && (
          <button onClick={() => handleScreenChange("login")}>Login</button>
        )}
    </div>


  );
}

export default App;
